import { BuiltinMemberValue } from '../BuiltinMemberValue';
export class SysCallMemberValue extends BuiltinMemberValue {
    constructor(syscall, type) {
        super();
        this.syscall = syscall;
        this.type = type;
    }
    emit(sb, node, options) {
        if (!options.pushValue) {
            return;
        }
        sb.emitSysCall(node, this.syscall);
        sb.emitHelper(node, options, sb.helpers.wrapVal({ type: this.type }));
    }
}

//# sourceMappingURL=SysCallMemberValue.js.map
